import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {Icon, PriorityIcon, Separator} from '@priority-software/priority-style-react';
import {deleteContainer, getContainerData} from '../actions/Field';
import {selectField} from '../../Common/actions/Screen';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {withElementRef, InjectedElementRefProps} from '../../../components/Fields/withElementRef';
import {ModernTooltip} from '../../../../components/Common/Tooltip/ModernTooltip';

interface Props {
    field: any;
}

@observer
class Container extends Component<Props & InjectedElementRefProps, any> {
    constructor(props) {
        super(props);

        this.deleteContainer = this.deleteContainer.bind(this);
        this.editContainer = this.editContainer.bind(this);
    }

    deleteContainer(e) {
        e.stopPropagation();
        const {field} = this.props;
        const {screen} = field;
        deleteContainer(screen, field);
    }

    editContainer(e) {
        e.stopPropagation();
        const {field} = this.props;
        // TODO: check if we still need this
        selectField(field);
        getContainerData(field);
    }

    render() {
        const {field, elementRef} = this.props;

        return (
            <div>
                <div className="field container" ref={elementRef}>
                    <span title={field.title}>{field.title}</span>
                    <div className="images container">
                        <div className="containers-buttons-area">
                            <ModernTooltip
                                tooltip={getLocalizedText(texts.editTooltipText)}
                                position="top-end"
                            >
                                <Icon
                                    icon={PriorityIcon.editFill}
                                    iconColor="primary-500"
                                    componentClasses="edit-sign-area"
                                    onClick={this.editContainer}
                                    style={{fontSize: '30px'}}
                                />
                            </ModernTooltip>
                            <Separator componentClasses="buttons-separator" />
                            <ModernTooltip tooltip={getLocalizedText(texts.del)} position="top-end">
                                <Icon
                                    icon={PriorityIcon.x}
                                    iconColor="primary-500"
                                    componentClasses="delete-sign-area"
                                    onClick={this.deleteContainer}
                                    style={{fontSize: '30px'}}
                                />
                            </ModernTooltip>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const ContainerField = withElementRef(Container);

export default ContainerField;
